import { Fragment, useState } from "react";
import { Link } from "react-router-dom";
import { useLocation } from "react-router-dom";
import {
  Accordion,
  AccordionSummary,
  Typography,
  AccordionDetails,
} from "@mui/material";
import useLocales from "../../hooks/useLocales";

const LinkItem = (idx: number, route: any, activeUrl: any) => (
  <li key={idx}>
    <Link
      to={route.path}
      title={route.name}
      className={`${activeUrl === route.path ? "active" : ""}`}
    >
      <i className={`icon-${route.icon}`}></i>
      <span className="nav-link-text" data-i18n="nav.blankpage">
        {route.label}
      </span>
    </Link>
  </li>
);

const LinkChildItem = (idx: number, route: any, activeUrl: any) => (
  <div className="li" key={idx}>
    <Link
      to={route.path}
      className={`${
        activeUrl === route.path
          ? "a waves-effect waves-themed active"
          : "a waves-effect waves-themed"
      }`}
    >
      <i className={`icon-${route.icon}`}></i>
      <span className="nav-link-text">{route.label}</span>
    </Link>
  </div>
);

const NavMenu = ({ leftSidebar }: any) => {
  const { translate } = useLocales();

  const [expanded, setExpanded] = useState();
  const [expandedChild, setExpandedChild] = useState();

  const handleChange = (panel: any) => (event: any, isExpanded: any) => {
    setExpanded(isExpanded ? panel : false);
  };

  const handleChangeChild = (panel: any) => (event: any, isExpanded: any) => {
    setExpandedChild(isExpanded ? panel : false);
  };

  const nav = [
    {
      id: 1,
      path: "/",
      name: "Home Page",
      label: translate("menu.home"),
      icon: "home",
    },
    {
      id: 3,
      path: "/applications",
      name: translate("menu.applications"),
      label: translate("menu.applications"),
      icon: "edit",
      children: [
        {
          id: 31,
          path: "/applications/create",
          name: translate("menu.create_new"),
          label: translate("menu.create_new"),
        },
        {
          id: 32,
          path: "/applications",
          name: translate("menu.application_list"),
          label: translate("menu.application_list"),
        },
      ],
    },
    /* {
      id: 3,
      path: "/invoice",
      name: translate("menu.invoice"),
      label: translate("menu.invoice"),
      icon: "invoice",
      children: [
        {
          id: 32,
          path: "/invoice/invoice-group/create",
          name: "Fatura Grubu Oluştur",
          label: "Fatura Grubu Oluştur",
        },
        {
          id: 31,
          path: "/invoice/invoice-group",
          name: translate("menu.invoice_group"),
          label: translate("menu.invoice_group"),
        },
      ],
    }, */
    /* {
      id: 2,
      path: "/customers",
      name: "Müşteriler",
      label: translate("menu.customers"),
      icon: "user",
    }, */
    {
      id: 3,
      path: "/customers",
      name: "Müşteriler",
      label: translate("menu.customers"),
      icon: "customer",
    },
    {
      id: 2,
      path: "/change-password",
      name: "Sifre Yenileme",
      label: translate("menu.reset_password"),
      icon: "vpn_key",
    },
  ];
  const location = useLocation();
  const { pathname } = location;
  const activeUrl = pathname;

  return (
    <>
      <div id="js-nav-menu" className="nav-menu">
        {leftSidebar ? (
          <>
            {nav.map((route, idx) => (
              <li key={idx}>
                <Link
                  to={route.path}
                  title={route.name}
                  className={`${activeUrl === route.path ? "active" : ""}`}
                >
                  <i className={`icon-${route.icon}`}></i>
                </Link>
                <>
                  {route.children !== undefined && (
                    <ul className="nav-sub-menu">
                      {route.children.map((child: any, index: any) => (
                        <li key={index}>
                          <Link
                            to={route.children !== undefined && child.path}
                            title={child.name}
                            className={`${
                              activeUrl === child.path ? "active" : ""
                            }`}
                          >
                            {child.name}
                          </Link>
                          <>
                            {child.children !== undefined && (
                              <ul className="nav-sub-menu">
                                {child.children.map(
                                  (subMenu: any, subIndex: number) => (
                                    <li key={subIndex}>
                                      <Link
                                        to={
                                          subMenu.children !== undefined &&
                                          subMenu.path
                                        }
                                      >
                                        {subMenu.name}
                                      </Link>
                                    </li>
                                  )
                                )}
                              </ul>
                            )}
                          </>
                        </li>
                      ))}
                    </ul>
                  )}
                </>
              </li>
            ))}
          </>
        ) : (
          <>
            {nav.map((route, idx) => (
              <Fragment key={idx}>
                {route.children !== undefined ? (
                  <Accordion
                    className="accordion-menu"
                    expanded={expanded === idx}
                    onChange={handleChange(idx)}
                  >
                    <AccordionSummary
                      aria-controls="panel1bh-content"
                      id="panel1bh-header"
                      className="accordion-menu-summary"
                    >
                      <i className={`icon-${route.icon}`} />
                      <Typography>{route.label}</Typography>
                      <div className="icon">
                        <i className="icon-arrow_forward_ios" />
                      </div>
                    </AccordionSummary>
                    <AccordionDetails className="accordion-menu-details">
                      {route.children?.map((child: any, index: number) => (
                        <Fragment key={index}>
                          {child.children !== undefined ? (
                            <Accordion
                              className="accordion-menu"
                              key={index}
                              expanded={expandedChild === index}
                              onChange={handleChangeChild(index)}
                            >
                              <AccordionSummary className="accordion-menu-summary">
                                <Typography>{child.label}</Typography>
                                <div className="icon">
                                  <i className="icon-arrow_forward_ios" />
                                </div>
                              </AccordionSummary>
                              <AccordionDetails className="accordion-menu-details">
                                {child.children.map(
                                  (subMenu: any, subIndex: number) => (
                                    <Fragment key={subIndex}>
                                      {subMenu.children !== undefined
                                        ? "Test"
                                        : LinkChildItem(
                                            idx,
                                            subMenu,
                                            activeUrl
                                          )}
                                    </Fragment>
                                  )
                                )}
                              </AccordionDetails>
                            </Accordion>
                          ) : (
                            LinkChildItem(idx, child, activeUrl)
                          )}
                        </Fragment>
                      ))}
                    </AccordionDetails>
                  </Accordion>
                ) : (
                  LinkItem(idx, route, activeUrl)
                )}
              </Fragment>
            ))}
          </>
        )}
      </div>
    </>
  );
};

export default NavMenu;
